<template>
    <div class="gmf-mini-lv-track">
        <div v-for="(lv, index) in lvArr" :key="lv" class="gmf-mini-lv-track--lv" :class="{
            'gmf-active': lv <= level,
            'gmf-clickable': clickable,
        }" @click="$emit('select', lv)">
            <div v-if="showLines && index == 0 && lv > 1" class="gmf-mini-lv-track--lv--line gmf-mini-lv-track--lv--line-start"
                :class="{ 'gmf-active': lv <= level }" />
            <div v-if="showLines && index < lvArr.length - 1" class="gmf-mini-lv-track--lv--line"
                :class="{ 'gmf-active': lv <= level - 1 }" />
            <div v-else-if="showLines && index == lvArr.length - 1 && maxLevel > lv"
                class="gmf-mini-lv-track--lv--line gmf-mini-lv-track--lv--line-end" />
            <Icon v-if="levelData[lv] && levelData[lv].icon && (lv <= level || showIconOnInactive)" :icon="levelData[lv].icon" :style="{
                '--gmf-icon-color': lv <= level ? levelData[lv].color : null,
            }" />
            <div v-else class="gmf-mini-lv-track--lv--dot" :style="{
                'background': levelData[lv] && lv <= level ? levelData[lv].color : null,
            }"></div>
        </div>
    </div>
</template>

<style>
.gmf-mini-lv-track {
    --gap: 4px;
    --line: 4px;
    --dot-size: 10px;
    --icon-outset: 3px;

    /*
    --gap: 3px;
    --line: 3px;
    --dot-size: 7px;
    */

    display: inline-flex;
    gap: var(--gap);
}

.gmf-mini-lv-track--lv {
    width: var(--dot-size);
    height: var(--dot-size);
    position: relative;
}

.gmf-mini-lv-track--lv--dot {
    width: var(--dot-size);
    height: var(--dot-size);
    background: var(--gmf-col-achievement-lv-track-bg);
    border-radius: 100%;
    position: absolute;
    z-index: 1;
}

.gmf-mini-lv-track--lv .gmf-icon {
    --gmf-icon-color: var(--gmf-col-achievement-lv-track-bg);
    position: absolute;
    inset: calc(0px - var(--icon-outset));
    width: calc(var(--dot-size) + var(--icon-outset) * 2);
    height: calc(var(--dot-size) + var(--icon-outset) * 2);
    z-index: 1;
}
.gmf-mini-lv-track--lv.gmf-active .gmf-icon {
    --outline-col: var(--gmf-col-white);
    --gmf-icon-color: var(--gmf-col-achievement-lv-track-fg);
    filter: 
        drop-shadow( 1px  0px 0px var(--outline-col))
        drop-shadow(-1px  0px 0px var(--outline-col))
        drop-shadow( 0px  1px 0px var(--outline-col))
        drop-shadow( 0px -1px 0px var(--outline-col));
}

.gmf-mini-lv-track--lv.gmf-active .gmf-mini-lv-track--lv--dot {
    background: var(--gmf-col-achievement-lv-track-fg);
}

.gmf-mini-lv-track--lv--line {
    background: var(--gmf-col-achievement-lv-track-bg);
    height: var(--line);
    width: calc(var(--gap) + var(--dot-size));
    position: absolute;
    top: calc((var(--dot-size) - var(--line)) / 2);
    z-index: 1;
    left: 50%;
}

.gmf-mini-lv-track--lv--line.gmf-active {
    background: var(--gmf-col-achievement-lv-track-fg);
}

.gmf-mini-lv-track--lv--line-end,
.gmf-mini-lv-track--lv--line-start {
    width: var(--dot-size);
}

.gmf-mini-lv-track--lv--line-start {
    left: unset;
    right: 50%;
    background: linear-gradient(to left, var(--gmf-col-achievement-lv-track-bg) 50%, #fff0)
}
.gmf-mini-lv-track--lv--line-end {
    background: linear-gradient(to right, var(--gmf-col-achievement-lv-track-bg) 50%, #fff0);
}

.gmf-mini-lv-track--lv--line-start.gmf-active {
    background: linear-gradient(to left, var(--gmf-col-achievement-lv-track-fg) 50%, #fff0)
}
.gmf-mini-lv-track--lv--line-end.gmf-active {
    background: linear-gradient(to right, var(--gmf-col-achievement-lv-track-fg) 50%, #fff0);
}
</style>

<script>
import Icon from '@/components/Icon.vue';

export default {
    name: 'MiniLevelTrack',
    components: {
        Icon,
    },
    props: {
        level: {
            type: Number,
            required: true,
        },
        maxLevel: {
            type: Number,
            required: true,
        },
        maxNumDots: {
            type: Number,
            default: 3,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
        levelData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            showLines: true,
            showIconOnInactive: true,
        };
    },
    computed: {
        lv() {
            return this.level > this.maxLevel ? this.maxLevel : this.level
        },
        lvArr() {
            if (this.maxLevel <= this.maxNumDots) {
                return Array.from({ length: this.maxLevel }, (v, k) => k + 1)
            }

            const half = Math.ceil(this.maxNumDots / 2);
            if (this.level > half) {
                const fromLevel = Math.min(this.level - half + 1, this.maxLevel - this.maxNumDots + 1);
                return Array.from({ length: this.maxNumDots }, (v, k) => k + fromLevel)
            }

            return Array.from({ length: this.maxNumDots }, (v, k) => k + 1)
        },
    }
}
</script>